import React from 'react';
import styled, { css } from '../../styled-components';
import { pixelToRem, media } from '../../utilities';

export interface IImageWithOutlineProps {
    src: string;
    alt: string;
    shapeOutline: string;
    className?: string;
    itemProp?: string;
    imageRef?: React.Ref<HTMLImageElement>;
}

const UnstyledImageWithShapeOutline: React.FC<IImageWithOutlineProps> = ({
    className,
    src,
    alt,
    itemProp,
    imageRef
}) => (
    <div className={className}>
        {src && <img src={src} alt={alt} itemProp={itemProp} ref={imageRef} />}
    </div>
);

export const ImageWithShapeOutline = styled(UnstyledImageWithShapeOutline)`
    ${({ shapeOutline }) => css`
        margin-bottom: ${pixelToRem(16)};

        ${media.m`
            float: right;
            margin-left: 2rem;
            shape-outside: url(${shapeOutline});
            shape-margin: 1rem;
        `}
    `}
`;
